export { WordReferenceDictionaryScreen } from "#word-reference-dictionary-screen";
